import { IBranchesFilters } from 'src/view/screens/BranchesManagementScreen/screens/BranchesScreen/types/branches';

export enum BRANCHES_COLUMN_NAME {
  NAME = 'name',
  PREORDER = 'preorder',
  CREATED_IN = 'created_in',
  FRANCHISEE_PROFILE = 'franchise_profile',
}

export const defaultBranchesFilters: IBranchesFilters = {
  sortField: undefined,
  sortDir: undefined,
  availability: null,
  search: '',
};

export enum BRANCHES_AVAILABILITY_OPTION {
  ACTIVE = 'branch_status_active',
  INACTIVE = 'branch_status_inactive',
  DELETED = 'deleted',
}

export const branchesFilterOptions = [
  { label: BRANCHES_AVAILABILITY_OPTION.ACTIVE, value: BRANCHES_AVAILABILITY_OPTION.ACTIVE },
  { label: BRANCHES_AVAILABILITY_OPTION.INACTIVE, value: BRANCHES_AVAILABILITY_OPTION.INACTIVE },
  { label: BRANCHES_AVAILABILITY_OPTION.DELETED, value: BRANCHES_AVAILABILITY_OPTION.DELETED },
];
